module.exports = __webpack_public_path__ + "static/healthcare-f027ca46d75cab3c400d8c4f9b234ea8.png";